import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Home.css';

/**
 * Page d'accueil BT-CONFIGURATEUR
 * Version adaptée pour intégration au site bt-regulation.fr
 * Contient 2 vignettes : Configurateur et Relevé de Chaufferie
 */
function Home() {
  const navigate = useNavigate();

  return (
    <div className="bt-home-container">
      {/* Header BT-Régulation */}
      <header className="bt-header">
        <div className="bt-header-content">
          <div className="bt-logo-section">
            <img
              src={`${process.env.PUBLIC_URL}/images/Logo1.png`}
              alt="BT Régulation"
              className="bt-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `${process.env.PUBLIC_URL}/images/Logo1.png`;
              }}
            />
            <div className="bt-logo-text">
              <h1>Configurateur BT-Régulation</h1>
              <p>Solutions de chauffage connecté</p>
            </div>
          </div>
          
          {/* Lien retour vers Accueil de bt-regulation.fr */}
          <a
            href="/"
            className="bt-btn bt-btn-outline"
            target="_parent"
            style={{ textDecoration: 'none' }}
          >
            ← Retour au site
          </a>
        </div>
      </header>

      {/* Contenu principal */}
      <main className="bt-main">
        <div className="bt-cards-container">

          {/* Vignette Configurateur */}
          <button
            className="bt-card"
            onClick={() => navigate('/configurator-home')}
            aria-label="Accéder au configurateur BT-Régulation"
          >
            <div className="bt-card-content">
              <div className="bt-card-icon">
                <img
                  src={`${process.env.PUBLIC_URL}/images/HYD.png`}
                  alt="Configurateur BT-Régulation"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <h2 className="bt-card-title">Configurateur BT-Régulation</h2>
              <p className="bt-card-description">
                Configurez votre solution BT-Régulation suivant vos besoins
              </p>
            </div>
          </button>

          {/* Vignette Relevé de Chaufferie */}
          <button
            className="bt-card"
            onClick={() => navigate('/audit-chaufferie')}
            aria-label="Accéder au formulaire de relevé chaufferie"
          >
            <div className="bt-card-content">
              <div className="bt-card-icon">
                <img
                  src={`${process.env.PUBLIC_URL}/images/AUDIT.png`}
                  alt="Relevé Chaufferie"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <h2 className="bt-card-title">Relevé de votre Chaufferie</h2>
              <p className="bt-card-description">
                Décrivez votre chaufferie pour recevoir notre préconisation
              </p>
            </div>
          </button>
          
        </div>
      </main>

      {/* Footer */}
      <footer className="bt-footer">
        <p>© 2025 BT Régulation - VIGILIA | Solutions de chauffage connecté</p>
        <p className="bt-footer-contact">
          Contact : <a href="mailto:contact@bt-regulation.fr">contact@bt-regulation.fr</a> |
          Tél : <a href="tel:0181939046">01 81 93 90 46</a>
        </p>
      </footer>
    </div>
  );
}

export default Home;
